import { BoxProps } from '@mui/material';
import React from 'react';
import { HOVER_ACTIONS_CLASS, HoverActionsRoot } from './HoverActionsCard.styles';

export { HoverActionsCard } from './HoverActionsCard.styles';

export const HoverActions = ({ className, ...props }: BoxProps) => (
  <HoverActionsRoot
    className={[HOVER_ACTIONS_CLASS, className].filter(Boolean).join(' ')}
    {...props}
  />
);
